// Generated by Melange

import * as Cn from "../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

function make(text) {
  return function (smallOpt) {
    const small = smallOpt !== undefined ? smallOpt : false;
    const match = React.useState(function () {
          return false;
        });
    const setHovered = match[1];
    const match$1 = React.useState(function () {
          return false;
        });
    const setCopied = match$1[1];
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
                      text: text,
                      onCopy: (function (param) {
                          Curry._1(setCopied, (function (param) {
                                  return true;
                                }));
                          setTimeout((function (param) {
                                  Curry._1(setCopied, (function (param) {
                                          return false;
                                        }));
                                }), 500);
                        }),
                      children: match$1[0] ? JsxRuntime.jsx("img", {
                              className: Cn.$plus("cursor-pointer w-5 h-5", Cn.on("!w-4 !h-4", small)),
                              src: StaticAsset.src("/static/icons/copy-check-20.svg")
                            }) : (
                          match[0] ? JsxRuntime.jsx("img", {
                                  className: Cn.$plus("cursor-pointer w-5 h-5", Cn.on("!w-4 !h-4", small)),
                                  src: StaticAsset.src("/static/icons/copy-black-20.svg")
                                }) : JsxRuntime.jsx("img", {
                                  className: Cn.$plus("cursor-pointer w-5 h-5", Cn.on("!w-4 !h-4", small)),
                                  src: StaticAsset.src("/static/icons/copy-gray-20.svg")
                                })
                        )
                    }),
                className: "hover:bg-gray-light rounded group-hover:block hidden",
                title: "Скопировать",
                onClick: (function (ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                  }),
                onMouseEnter: (function (param) {
                    Curry._1(setHovered, (function (param) {
                            return true;
                          }));
                  }),
                onMouseLeave: (function (param) {
                    Curry._1(setHovered, (function (param) {
                            return false;
                          }));
                  })
              });
  };
}

function CopyButton(Props) {
  return make(Props.text)(Props.small);
}

const timeout = 500;

const make$1 = CopyButton;

export {
  timeout ,
  make$1 as make,
}
/* react Not a pure module */
